<section class="flex flex-col w-full max-w-3xl mx-auto px-2 sm:px-3 gap-6 min-w-0 overflow-x-hidden">
  <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
    <div class="min-w-0">
      <h1 class="text-xl sm:text-2xl font-bold text-gray-800">Mes alertes</h1>
      <p class="text-sm text-gray-600 mt-1">Indicateurs basés sur les annonces (dépôts de comptes) pour votre entreprise.</p>
    </div>
    <button type="button" (click)="sync()" [disabled]="syncing()"
            class="inline-flex w-full sm:w-auto items-center justify-center gap-2 px-3 py-2.5 sm:py-2 text-sm bg-secondary text-white rounded-md hover:bg-secondary-hover disabled:opacity-60 cursor-pointer shrink-0">
      <lucide-icon [name]="RefreshCw" size="16" [class.animate-spin]="syncing()"></lucide-icon>
      Actualiser
    </button>
  </div>

  <div class="space-y-3">
    @for (row of obligations(); track row.label) {
      <div class="rounded-lg border p-4" [ngClass]="statusClass(row.status)">
        <div class="flex items-start gap-3">
          @if (row.status === 'ok') {
            <lucide-icon [name]="CheckCircle2" size="20" class="shrink-0 mt-0.5"></lucide-icon>
          }
          <div>
            <p class="font-semibold">{{ row.label }}</p>
            <p class="text-sm mt-1 opacity-90">{{ row.detail }}</p>
          </div>
        </div>
      </div>
    } @empty {
      <p class="text-sm text-gray-500">Pas assez d’historique pour afficher des obligations.</p>
    }
  </div>
</section>
